var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-header"},[_c('div',{staticClass:"form-header__title font--bold -xl -color1 mt-12 mb-3"},[_c('span',{staticClass:"ml-3"},[_vm._v(_vm._s(_vm.header))])])])}
var staticRenderFns = []

export { render, staticRenderFns }